<template>
	<div id="app">
		<transition name="fade"   mode="out-in">
			<div>
				<keep-alive >	
					<router-view v-if="$route.meta.keepAlive"></router-view>
				</keep-alive>
				<router-view v-if="!$route.meta.keepAlive"></router-view>
			</div>
			
		</transition>
	</div>
</template>

<script>	
	// import VueRouter from 'vue-router'
	// import LoginView from './views/LoginView';
	// import NotFound from './views/404View.vue'
	// import HomeView from './views/HomeView.vue'
	// import MainView from './views/MainView.vue'
	// import {mapping} from './route-mapping';

	export default {
		name: 'app',
		data() {
			return {
				isLogin: false,
			};
		},
		// components: {
		// 	LoginView
		// },
		mounted() {
			var user = sessionStorage.getItem('user');
			// if (user) {
			// 	this.isLogin = true;
			// }
		}, 
		methods: {

			// initDefaultRoutes(){
				
			// 	// 默认的跳转路径
			// 	let routes = [
			// 		{
			// 			path: '/login',
			// 			component: LoginView,
			// 			name: '',
			// 			hidden: true
			// 		},
			// 		{
			// 			path: '/404',
			// 			component: NotFound,
			// 			name: '',
			// 			hidden: true
			// 		},
			// 		{
			// 			path: '*',
			// 			hidden: true,
			// 			redirect: { path: '/404' }
			// 		},     
			// 	];	

			// 	return routes;
			// },

			// 根据得到的服务器数据拼菜单
		// 	initUserMenu(user){

		// 		let routes = this.initDefaultRoutes();

		// 		var parentMenus = user.parentMenus;

		// 		for(var i=0; i < parentMenus.length; i++){
		// 			let parent = parentMenus[i];
		// 			let r = {
		// 				path: '/',
		// 				component: HomeView,
		// 				name: parent.label,
		// 				iconCls: parent.icon,
		// 			}

		// 			let children = [];
		// 			for(var k=0; k < parent.childMenus.length; k++){
		// 				let child = parent.childMenus[k];
		// 				let component = mapping[child.link];
		// 				if(!component){
		// 					throw new error("菜单链接不正确. child.link: " + child.link);
		// 				}
		// 				children.push({
		// 					path: child.link, 
		// 					component: component, 
		// 					name: child.label,
		// 				});
		// 			}

		// 			r['children'] = children;

		// 			routes.push(r);
		// 		}


		// 		const router = new VueRouter({
		// 			routes
		// 		})

		// 		router.beforeEach((to, from, next) => {
		// 			//NProgress.start();
		// 			if (to.path == '/login') {
		// 				sessionStorage.removeItem('user');
		// 			}
		// 			let user = JSON.parse(sessionStorage.getItem('user'));
		// 			if (!user && to.path != '/login') {
		// 				next({ path: '/login' })
		// 			} else {
		// 				next()
		// 			}
		// 		})

		// 		this.$router = router;

		// 		this.isLogin = true;
		// 	},
		},
	}

</script>

<style lang="scss">
@import '../src/assets/css/fontFace';
body {
	margin: 0px;
	padding: 0px;
	/*background: url(assets/bg1.jpg) center !important;
		background-size: cover;*/
	// background: #1F2D3D;
	// font-family:WenQuanYi Micro Hei,Source Han Sans CN,Source Han Serif SC,PingFang-SC-Medium,Microsoft YaHei,SimSun,SimHei;
	font-family: 'pingFang-M';
	font-size: 14px;
	-webkit-font-smoothing: antialiased;
}
input, textarea, select, button{
	// font-family:WenQuanYi Micro Hei,Source Han Sans CN,Source Han Serif SC,PingFang-SC-Medium,Microsoft YaHei,SimSun,SimHei;
	font-family: 'pingFang-M';
}
#app {
	font-family: 'pingFang-M';
	// position: absolute;
	// top: 0px;
	// bottom: 0px;
	// width: 100%;
}

.el-submenu [class^=fa] {
	vertical-align: baseline;
	margin-right: 10px;
}

.el-menu-item [class^=fa] {
	vertical-align: baseline;
	margin-right: 10px;
}

.fade-enter-active,
.fade-leave-active {
	transition: all .2s ease;
}

.fade-enter,
.fade-leave-active {
	opacity: 0;
}

.el-menu-vertical-demo.el-menu{
	width: 230px;
}
</style>


// WEBPACK FOOTER //
// App.vue?a76ff906